{
  "Seguimiento del pedido": "Suivi de la commande",
  "Enviado": "Expédié",
  "Empaquetado": "Emballé",
  "Recibido": "Reçu",
  "Items del pedido": "Articles de la commande",
  "En proceso": "En cours",
  "Devolución solicitada": "Retour demandé",
  "Devolución en proceso": "Retour en cours",
  "Devuelto": "Retourné",
  "Envío": "Expédition",
  "Devolución": "Retour",
  "Ver en tienda": "Voir dans le magasin",
  "Solicitudes de devolución": "Demandes de retour",
  "Envíos": "Expéditions",
  "Confirmado": "Confirmée",
  "En curso": "En cours",
  "Seguimiento de envío": "Suivi de l'envoi",
  "Destino": "Destination",
  "Dirección destino": "Adresse de destination",
  "Última actualización": "Dernière mise à jour",
  "Devolución pendiente": "Retour en attente",
  "Recogida solicitada": "Collecte demandée",
  "Devolución enviada": "Retour envoyé",
  "Entrega estimada": "Livraison estimée",
  "Valora tu experiencia con nosotros": "Évaluez votre expérience avec nous",
  "¡Gracias!": "Merci !",
  "Mensaje de alerta": "Message d'alerte",
  "Punto de recogida": "Point de retrait",
  "Mostrar historial completo": "Afficher l'historique complet",
  "Ocultar historial": "Masquer l'historique",
  "¿Necesitas hacer una devolución o cambio?": "Vous souhaitez retourner ou échanger un article ?",
  "¿Quieres devolver algo más?": "Vous souhaitez retourner autre chose ?",
  "Devuelve o cambia tu artículo en pocos pasos.": "Retournez ou échangez votre article en quelques étapes simples.",
  "Empieza el proceso en pocos pasos. Te guiaremos durante todo el proceso.": "Commencez en quelques étapes simples. Nous vous guiderons tout au long du processus.",
  "Abrir el portal de devoluciones": "Accéder au portail de retours",
  "Enviando": "Envoi en cours",
  "¡Página no encontrada!": "Page introuvable !",
  "Lo sentimos, pero no se pudo encontrar la página que estabas buscando": "Désolé, la page que vous cherchiez est introuvable",
  "Puedes volver al ": "Vous pouvez revenir au ",
  "principio": "début",
  "o escribirnos a support@reveni.io si no encuentras lo que estabas buscando": "ou nous écrire à support@reveni.io si vous ne trouvez pas ce que vous cherchiez"
}
